if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }


      async loadPage(url) {
        this.loader = document.querySelector("#loader");
        if (this.loader) this.loader.style.display = "flex";

        this.renderProductInfo({
          requestUrl: url,
          targetId: '', // не фокусуємо жоден елемент
          callback: this.handleSwapProduct(url, false), // true → повне оновлення product-info
        });
      }


      // async loadPage(url) {   //console.log(221, url, 'loadPage');
      //   this.loader = document.querySelector("#loader");
      //   this.loader.style.display = "flex";

      //   const res = await fetch(url);
      //   const html = await res.text();
      //   const parser = new DOMParser();
      //   const doc = parser.parseFromString(html, "text/html");
      //   const newContent = doc.querySelector(".main-product-ajax-container");
      //   const newTitle = doc.title;

      //   if (newContent) {
      //     // Оновлюємо тільки вибрані елементи всередині this (тобто <main-product>)
      //     const selectorsToUpdate = [
      //       // '.product__title',       // або #price-{{ section.id }}
      //       '.product__info-container',
      //       '.breadcrumbs',
      //       // 'variant-selects',
      //       // '.price'
      //     ];

      //     selectorsToUpdate.forEach((selector) => { console.log('ss', selector)
      //       const newEls = newContent.querySelectorAll(selector);
      //       const currentEls = this.querySelectorAll(selector);

      //       newEls.forEach((newEl, index) => {
      //         const currentEl = currentEls[index];
      //         if (newEl && currentEl) {
      //           currentEl.innerHTML = newEl.innerHTML;
      //         }
      //       });
      //     });

      //     document.title = newTitle;
      //     // history.pushState({}, "", url);
          
      //     setTimeout(() => {   console.log(22)
      //       this.init  ShopifyFeatures?.();
      //       // this.initGallery?.();
      //       this.updateOptionValues(doc);

      //       let productUrl = url.split('.com')
      //       // this.handleUpdateProductInfo(productUrl[1])
      //       const variant = this.getSelectedVariant(doc);

      //       this.updateURL(productUrl[1], variant?.id);
      //       this.updateVariantInputs(variant?.id);
      //     }, 1000);

      //     this.loader.style.display = "none";
      //   }
      // }


      initGallery() {
        setTimeout(() => {
          let sliderThumbs = new Swiper('.slider--thumbs', {
            slidesPerView: 3,
            spaceBetween: 9,
            loop: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            freeMode: true,
            breakpoints: {
              0: {
                slidesPerView: 3,
              },
              550: {
                slidesPerView: 4,
              },
              750: {
                slidesPerView: 3,
              },
              990: {
                slidesPerView: 4,
              },
            },
          });

          let sliderProductMain = new Swiper('.slider--main', {
            spaceBetween: 0,
            slidesPerView: 'auto',
            loop: true,
            grabCursor: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              type: 'bullets',
              el: ".swiper-pagination",
              clickable: true,
              enable: true,
            },
            thumbs: {
              swiper: sliderThumbs,
            },
            breakpoints: {
              750: {
                slidesPerView: 'auto',
                spaceBetween: 10,
                centeredSlides: false,
                initialSlide: 0,
              },
              990: {
                slidesPerView: 'auto',
                spaceBetween: 30,
                centeredSlides: false,
              },
            }
          });
        }, 400);
      }

      initShopifyFeatures() {
        window.Shopify && Shopify.bind && Shopify.bind();
      }
      connectedCallback() {
        this.loader = document.querySelector("#loader");

        this.addEventListener("click", (e) => {
          const link = e.target.closest("a");  // console.log('click', link)
          if (
            link &&
            link.href.includes("/products/") &&
            link.origin === location.origin &&
            !link.hasAttribute("data-no-ajax") &&
            link.classList.contains("js-meta-variants")
          ) {
            e.preventDefault();

            let activeSize = this.querySelector('#rtr_carat input[type=radio]:checked').value
            let activeShape = this.querySelector('#rtr_shapes input[type=radio]:checked').value

            this.loadPage(link.href);
            setTimeout(() => {
              
              this.initGallery?.();

              let activeSizeInput = document.querySelector(`#rtr_carat input[value="${activeSize}"]`);
              // if(activeSizeInput) activeSizeInput.click();
              if(activeSizeInput) activeSizeInput.checked = true;

              //setTimeout(() => {
                let activeShapeInput = document.querySelector(`#rtr_shapes input[value="${activeShape}"]`);
                if(activeShapeInput){
                    // activeShapeInput.click();
                    activeShapeInput.checked = true;
                    // debugger;

                    activeShapeInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
             // }, 5000);

            }, 4000); // need so big timeout becouse of 3d preview can run before it.


            // NEW PART
            // e.preventDefault();
            // const url = link.href;
            // let sectionId = link.dataset.sectionId;
            // // Ваша функція, що оновлює <product-info>
            // if (typeof this.loadAlternativeProduct === 'function') {   // console.log(2222, url, sectionId)
            //   this.loadAlternativeProduct(url, sectionId);

            // } else {  // console.log(333)
            //   // запасний варіант – повне оновлення сторінки
            //   window.location.href = url;
            // }
          }
        });

        window.addEventListener("popstate", () => {   // console.log('popstate')
          // this.loadPage(location.href);
        });

        // connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      async loadAlternativeProduct(url, sectionId) {
        try {
          const response = await fetch(`${url}?section_id=${sectionId}`);
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // console.log(111, url + `?section_id=shopify-section-${sectionId}`)
          // console.log(222, doc)

          const newSection = doc.querySelector('product-info');
          const currentSection = document.querySelector('product-info');

          if (newSection && currentSection) {
            currentSection.replaceWith(newSection);

            // Перевиклик ініціалізації
            initProductInfo(newSection);
            // fnc_init_3d_Go_1();
          } else {
            console.warn('No section');
          }
        } catch (e) {
          console.error('Помилка при завантаженні альтернативного продукту:', e);
        }
      }


      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            if (this.loader) this.loader.style.display = "none";
            // set focus to last clicked option value
            if(targetId){
              document.querySelector(`#${targetId}`)?.focus();
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      galleryUpdate(html) { //code for update gallery
        const newGallery = html.querySelector('.slider--main');
        let slider = document.querySelector('.slider--main');
        if ( slider && newGallery ) {
          slider.innerHTML = newGallery.innerHTML;
        }

        const newGalleryThumbs = html.querySelector('.slider--thumbs');
        let sliderThumbs = document.querySelector('.slider--thumbs');
        if ( sliderThumbs && newGalleryThumbs ) {
          sliderThumbs.innerHTML = newGalleryThumbs.innerHTML;
        }

        if ( slider.closest('.quick-add-modal') ) {
          let sliderProductQuick = new Swiper('.quick-add-modal .slider--main', {
            slidesPerView: 1,
            spaceBetween: 0,
            watchOverflow: false,
            resistanceRatio: true,
            breakpoints: {
              320: {
                slidesPerView: 5.5,
                spaceBetween: 0
              },
              750: {
                slidesPerView: 1.15,
                spaceBetween: 5,
              }
            },
            on: {
              touchMove: function (swiper) {
                const translate = swiper.getTranslate();
                const maxTranslate = swiper.width - swiper.slides[0].offsetWidth;

                if (translate > 0) {
                    swiper.setTranslate(0);
                } else if (translate < -maxTranslate) {
                    swiper.setTranslate(-maxTranslate);
                }
              }
              }
          });
        } else {
          window?.initProductInfo();
        }
      }//end code for update gallery

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }
          
          // console.log('galleryUpdate');
          // this.galleryUpdate(html);   // закоментив для product-preset-ring template але здається що воно взагалі не треба, бо слайдер ініціюється в product-media-gallery.liquid а реінітити його ще раз не треба. Потикав різні продукти галерея працювала ОК.

          // this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
